"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var react_1 = require("swiper/react");
var SwiperNavArrows_1 = require("../../Swiper/SwiperNavArrows");
var hooks_1 = require("preact/hooks");
var color_1 = require("../common/color");
var Parser_1 = require("../Parser");
var ImgWithPlaceholder_1 = require("../common/ImgWithPlaceholder");
var media_query_1 = require("../../hooks/media-query");
var ScienceContent = function (_a) {
    var color = _a.color, scienceData = _a.scienceData, setTabIndex = _a.setTabIndex, tabIndex = _a.tabIndex;
    var isDesktop = (0, media_query_1.useMediaQuery)('(min-width: 1025px)');
    var _b = (0, hooks_1.useState)(null), swiper = _b[0], setSwiper = _b[1];
    (0, hooks_1.useEffect)(function () {
        if (swiper) {
            swiper.slideToLoop(tabIndex);
        }
    }, [tabIndex]);
    return ((0, preact_1.h)(react_1.Swiper, { class: "science-section-swiper", loop: true, onRealIndexChange: function (s) { return setTabIndex(s.realIndex); }, onSwiper: setSwiper },
        scienceData.tabs.length > 1 && (0, preact_1.h)(SwiperNavArrows_1.default, { bgColor: scienceData.color }),
        scienceData.tabs.map(function (tab) { return ((0, preact_1.h)(react_1.SwiperSlide, null,
            (0, preact_1.h)("div", { class: "science-content" },
                (0, preact_1.h)(ImgWithPlaceholder_1.default, { alt: tab.title, class: "science-content__image", src: isDesktop ? tab.imageUrlDesktop : tab.imageUrlMobile, placeholderSrc: isDesktop ? tab.staticImageUrlDesktop : tab.staticImageUrlMobile }),
                (0, preact_1.h)("div", { class: "science-content__facts" },
                    tab.details.map(function (detail, index) {
                        return ((0, preact_1.h)("div", { class: "science-content__fact ".concat(index === 1 ? 'science-content__fact--secondary' : ''), key: index },
                            (0, preact_1.h)("p", { class: "science-content__title", style: scienceData.version === 'v2'
                                    ? {
                                        borderColor: (0, color_1.toHex)(color),
                                        backgroundColor: (0, color_1.toHex)(color),
                                        color: '#ffffff',
                                    }
                                    : { color: (0, color_1.toHex)(color) } }, detail.title),
                            (0, preact_1.h)("p", { class: "science-content__description" }, (0, Parser_1.parse)(detail.description))));
                    }),
                    scienceData.divider && ((0, preact_1.h)("img", { alt: "science fact divider", class: "science-content__divider", src: scienceData.divider })))))); })));
};
exports.default = ScienceContent;
